import JsFunction from './JsFunction';

const templateInput = ({ buttonId, arrayName, resultPanelId, inputId }) => `const ${arrayName} = [];
document.getElementById("${buttonId}").onclick = event => {
  event.preventDefault();
 ${arrayName}.push(document.getElementById("${inputId}").value);
 document.getElementById("${inputId}").value = "";
    let e=\`\`;
   for (let y=0; y<${arrayName}.length; y++)
   {
     e += \`<li arrayvalue='\${${arrayName}[y]}'>\${${arrayName}[y]}</li>\`;
   }
   document.getElementById("${resultPanelId}").innerHTML = e;
};`;

const refreshTemplate = ({ resultPanelId, arrayName }) => `
function refreshUL${resultPanelId}() {
let e=\`\`;
for (let y=0; y<${arrayName}.length; y++)
 {
   e += \`<li index='\${y}' arrayvalue='\${${arrayName}[y].value}'><p style="display: inline-block">\${${arrayName}[y].liValue}</p><button class="btn pointer bi bi-trash delete-btn" style="display: inline-block;float: right;background-color: red;color: white;" index='\${y}'>&nbsp;Delete</button></li>\`;
 }
document.getElementById("${resultPanelId}").innerHTML = e;
}
`;

const deleteEventTemplate = ({
  resultPanelId,
  arrayName
}) => `document.getElementById("${resultPanelId}").addEventListener("click", event => {
  event.preventDefault();
  ${arrayName} = ${arrayName}.filter(
    (item, index) => +event.target.getAttribute("index") !== index
  );
  refreshUL${resultPanelId}();
});`;

const initializeArrayTemplate = ({
  arrayName,
  subEntityAttr
}) => `function initialize${arrayName}(data) {
  ${arrayName} = data.map(item => ({
    value: item._id,
    liValue: item[${subEntityAttr ? `'${subEntityAttr}'` : `' '`}]
  }));
}`;

const templateSelect = ({
  buttonId,
  arrayName,
  resultPanelId,
  inputId,
  subEntityAttr
}) => `let ${arrayName} = [];
document.getElementById("${buttonId}").onclick = event => {
  event.preventDefault();
  const select = document.getElementById("${inputId}")
  ${arrayName}.push({
      value: select.value,
      liValue: select.selectedOptions[0].textContent
  });
  select.value = "";
  select.selectedIndex = 0;
  refreshUL${resultPanelId}();
};
${refreshTemplate({ arrayName, resultPanelId })}
${deleteEventTemplate({ arrayName, resultPanelId })}
${initializeArrayTemplate({ arrayName, subEntityAttr })}
`;

const templates = {
  INPUT: templateInput,
  SELECT: templateSelect
};

export default class InputArrayFunction extends JsFunction {
  inputDataTemplate = '';

  arrayNamePrefix = 'array';

  constructor(method, annotations, htmlDom) {
    super(method, annotations, htmlDom);
    this.componentId = method.compId;
    // TODO: this should be deleted since it is not being used
    this.inputDataTemplate = method.inputDataTemplate;
    this.containerItem = htmlDom.getElementById(method.compId);
    this.addButton = this.containerItem.querySelector('[addToPanel="true"');
    this.inputElement = this.containerItem.querySelector('[inputElement="true"]');
    this.panelToShowInput = this.containerItem.querySelector('[panelToShowInput="true"]');
    this.subEntityAttr = this.containerItem
      .querySelector('[attached-subentity-attr]')
      ?.getAttribute('attached-subentity-attr');
  }

  printFunction() {
    super.clearfunctionNextTemplate();

    return templates[this.inputElement.tagName]({
      buttonId: this.addButton.id,
      arrayName: `${this.arrayNamePrefix}${this.componentId}`,
      resultPanelId: this.panelToShowInput.id,
      inputId: this.inputElement.id,
      subEntityAttr: this.subEntityAttr
    });
  }
}
